import React, { useState } from 'react';
import { string } from 'prop-types';
import Popover from 'ps-components/Popover/Popover';
import classnames from 'classnames';
import './SearchInfo.scss';

Placeholder.propTypes = {
  className: string
};

const searchOperatorDescriptions = [
  {
    title: '" search term "',
    description: 'Search for an exact match.',
    example: 'E.g. "Senior Accountant"'
  },
  {
    title: 'OR',
    description: 'Search for both A or B. This will return results related to A or B, or both.',
    example: 'E.g. Senior Accountant OR Entry Accountant'
  },
  {
    title: 'AND',
    description: 'Search for A and B. This will return only results related to both A and B.',
    example: 'E.g. Accountant AND Entry'
  },
  {
    title: 'NOT',
    description: 'Search for NOT A. This will return results that do not have a relation to A.',
    example: 'E.g. NOT Accountant'
  }
];

export default function Placeholder(props) {
  const { className } = props;
  const [searchInputShow, setSearchInputShow] = useState(false);

  function toggleSearchInputShow(event) {
    event?.stopPropagation();
    setSearchInputShow(!searchInputShow);
  }

  return (
    <span className={classnames('icon-reverse icon-circle market-pricing__search-info', className)}>
      <i
        onClick={toggleSearchInputShow}
        title="Search operator descriptions"
        className="icon-info market-pricing__search-info-icon"
      />
      <span className="market-pricing__search-info-popover" id="market-pricing__search-info-popover">
        {searchInputShow && (
          <Popover
            popoverClassnames="market-pricing__search-info-popover-inner"
            relativeElement={document.querySelector('span#market-pricing__search-info-popover')}
            display={true}
            arrowAlign="center"
            togglePopover={toggleSearchInputShow}
          >
            {searchOperatorDescriptions.map((operator, idx) => (
              <div className="search-operator__popover" key={'operator' + idx}>
                <div className="search-operator__title">{operator.title}</div>
                <div className="search-operator__description">{operator.description}</div>
                <div className="search-operator__example">{operator.example}</div>
              </div>
            ))}
          </Popover>
        )}
      </span>
    </span>
  );
}
